import {isFunction} from '@config/utils'
import LayerGroup from 'ol/layer/Group';
import Collection from 'ol/Collection';
import {
    TileImage as TileImageSource,
    TileWMS as TileWMSSource,
    ImageWMS as ImageWMSSource,
    XYZ as XYZSource,
    WMTS as WMTSSource,
    Vector as VectorSource,
    Cluster as ClusterSource,
}  from 'ol/source';

import TileImageSerializer from '../serializer/TileImage';
import TileWMSSerializer from '../serializer/TileWMS';
import ImageWMSSerializer from '../serializer/ImageWMS';
import XYZSerializer from '../serializer/XYZ';
import VectorSerializer from '../serializer/Vector';
import WMTSSerializer from '../serializer/WMTS';
import ClusterSerializer from '../serializer/Cluster';

export default {
    data() {
        return {
            capabilities: null,
            serializers: [],
        }
    },
    mounted() {
        // IMPORTANT!! THE ORDER IS MATHERS BECAUSE THE INHERITANCE!!
        this.registerSerializer(TileWMSSource, TileWMSSerializer);
        this.registerSerializer(XYZSource, XYZSerializer);
        this.registerSerializer(WMTSSource, WMTSSerializer);
        this.registerSerializer(ClusterSource, ClusterSerializer);
        this.registerSerializer(ImageWMSSource, ImageWMSSerializer);
        this.registerSerializer(TileImageSource, TileImageSerializer);
        this.registerSerializer(VectorSource, VectorSerializer);
    },
    computed: {
        urlCapabilities(){
            return this.url.capabilitiesPrint;
        }
    },
    methods: {
        async loadCapabilitiesPrint(){
            let response =  await this.$http.get(this.urlCapabilities)
                .then(res => {
                    let data = res.data ? res.data : res;
                    let capabilities = this.capabilities = Object.assign({}, data.data ? data.data : data);
                    return capabilities;
                })
                .catch(error => {
                    this.showHttpError(error);
                    return null;
                })
            if(!response){
                this.showError('Não foi possivel obter as configurações para a impressão');
            }
            return response;
        },
        /**
         * Registers the passed serializer class as an appropriate serializer
         * for the passed OpenLayers source class.
         *
         * @param {ol.source.Source} olSourceCls The OpenLayers source class
         *    that the passed serializer can serialize.
         * @param {object} serializerCls The serializer
         *    that can serialize the passed source.
         */
        registerSerializer: function(olSourceCls, serializerCls) {
            this.serializers.push({
                olSourceCls: olSourceCls,
                serializerCls: serializerCls
            });
        },
        /**
        * Will return an array of serialized layers for print servlet
        */
        getSerializedLayers: function(mapComponent, filterFn, filterScope, layers = undefined) {
            layers = layers ?? mapComponent.getLayers();
            let viewRes = mapComponent.getView().getResolution();
            let serializedLayers = [];

            // let group = new LayerGroup({
            //       layers: [
            //         new TileLayer({
            //           source: new TileJSONSource({
            //             url: 'http://api.tiles.mapbox.com/v3/' +
            //                 'mapbox.20110804-hoa-foodinsecurity-3month.jsonp',
            //             crossOrigin: 'anonymous'
            //           })
            //         }),
            //         new TileLayer({
            //           source: new TileJSONSource({
            //             url: 'http://api.tiles.mapbox.com/v3/' +
            //                 'mapbox.world-borders-light.jsonp',
            //             crossOrigin: 'anonymous'
            //           })
            //         })
            //       ]
            //     });
            // layers = new Collection([group]);

            let inputLayers = this.getLayerArray(layers);
            if (typeof filterFn !== 'undefined' && isFunction(filterFn)) {
                inputLayers = inputLayers.filter((layer) => {
                    return filterFn.call(filterScope, layer);
                });
            }

            inputLayers.forEach((layer) => {
                let source = layer.getSource();
                let serialized = {};
                let serializer = this.findSerializerBySource(source);
                if (serializer) {
                    serialized = (new serializer).serialize(layer, source, viewRes, mapComponent);
                    serializedLayers.push(serialized);
                }
            });

            return serializedLayers;
        },
        /**
         * Will return an array of ol-layers by the given collection. Layers
         * contained in `ol.layer.Group`s get extracted and groups get removed
         * from returning array
         */
        getLayerArray: function(coll) {
            let me = this;
            let inputLayers = [];
            let outputLayers = [];

            // if (coll instanceof GeoExt.data.store.Layers) {
            if (false) {
                coll.each(function(layerRec) {
                    let layer = layerRec.getOlLayer();
                    inputLayers.push(layer);
                });
            } else if (coll instanceof Collection) {
                inputLayers = [...coll.getArray()];
            } else {
                inputLayers = [...coll];
            }

            inputLayers.forEach((layer) => {
                if (layer instanceof LayerGroup) {
                    this.getLayerArray(layer.getLayers()).forEach((subLayer) => {
                        if(subLayer.getVisible() === true){
                            return outputLayers.push(subLayer);
                        }
                    });
                } else {
                    if(layer.getVisible() === true){
                        outputLayers.push(layer);
                    }
                }
            });
            let outputLayers2 = outputLayers.sort((a, b) => {
                return a.getZIndex() < b.getZIndex() ? -1 : a.getZIndex() > b.getZIndex() ? 1 : 0;
            });
            return outputLayers;
        },
        /**
         * Returns a Object capable of serializing the
         * passed source instance or undefined, if no such serializer was
         * previously registered.
         *
         * @param {ol.source.Source} source The source instance to find a
         *    serializer for.
         * @return {Object} A serializer for the passed
         *    source or `undefined`.
         */
        findSerializerBySource: function(source) {
            let available = this.serializers;
            let serializer;

            let candidate = available.find((candidate) => {
                // if (source.constructor.name === 'cTMS'
                //     && candidate.olSourceCls.name === 'WMTS') {
                //     console.log(':', 'WMTS', source);
                //     return true;

                // } else if (source.constructor.name === 'CityhubCluster'
                //     && candidate.olSourceCls.name === 'Cluster') {
                //     console.log(':', 'Cluster', source);
                //     return true;

                // } else if (source instanceof candidate.olSourceCls
                //     // && candidate.olSourceCls.name !== 'TileImage'
                //     // && source.constructor.name !== 'CityhubCluster'
                //     ) {
                //     console.log(':', 'OUTRO', candidate.olSourceCls.name, source.constructor.name);
                //     return true;
                // }
                // console.log(':', source.constructor.name ,
                //     candidate.olSourceCls.name,
                //     Object.getPrototypeOf(source.constructor).name,
                //     source instanceof candidate.olSourceCls);

                return source instanceof candidate.olSourceCls;
                // THIS LINE DON'T WORK ON PRODUCTION
                // return source.constructor.name === candidate.olSourceCls.name;
            });

            if (!candidate) {
                this.showWarning('Couldn\'t find a suitable serializer for source.'
                    + ' Did you require() an appropriate serializer class?', this.title);
                return null;
            }

            return candidate.serializerCls;
        },
    },
    watch: {
    },
};
